'use client';

import '../styles/globals.css';
import { InterFont } from '@/styles/fonts';
import { ThemeProvider } from '@/styles/ThemeProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import NextTopLoader from 'nextjs-toploader';
import config from '@/lib/config/site';
import { SpeedInsights } from '@vercel/speed-insights/next';
import { Analytics } from '@vercel/analytics/react';// Import React Query
import Script from 'next/script';
import { metadata } from '@/components/Metadata'
import ClientProviders from './client-providers';


export default function RootLayout ({ children, } 
: {
  children: React.ReactNode
}) {

  return (
    <html suppressHydrationWarning
lang="en"
className={`${InterFont.variable}`}>
      <head>
        <title>{metadata.title as React.ReactNode}</title>
        <Script
          strategy="afterInteractive"
          src={`https://www.googletagmanager.com/gtag/js?id=${config.seo_title}`}
        />
        <Script
          id="google-analytics"
          strategy="afterInteractive"
        >
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${config.ga4_measurement_id}');
          `}
        </Script>
      </head>  
      {/* <body className="bg-gradient-to-br from-green-400 via-teal-500 to-blue-600 h-screen text-red-900 mx-2"> */}
      <body className="mx-2">
        <ThemeProvider attribute="class"
defaultTheme="light"
enableSystem
disableTransitionOnChange>
          {/* Step 3: Wrap the application in QueryClientProvider */}
          <ClientProviders>  
              <NextTopLoader color={config.loading_bar_color} />
              {children}
              <ToastContainer position="top-right" />            
              </ClientProviders>
        </ThemeProvider>
        <SpeedInsights />
        <Analytics />
      </body>
    </html>
  );
};

